import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { graphicTool } from './GraphicTool';

export const graphicToolboxItem = ToolboxItem({
    id: 'graphicTool',
    label: 'Images',
    weight: 1040,
    tools: [graphicTool]
});
